import { render, staticRenderFns } from "./moreAnalytics2.vue?vue&type=template&id=3524c36e&"
import script from "./moreAnalytics2.vue?vue&type=script&lang=js&"
export * from "./moreAnalytics2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3524c36e')) {
      api.createRecord('3524c36e', component.options)
    } else {
      api.reload('3524c36e', component.options)
    }
    module.hot.accept("./moreAnalytics2.vue?vue&type=template&id=3524c36e&", function () {
      api.rerender('3524c36e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/moreAnalytics2.vue"
export default component.exports